import { useEffect } from 'react'
import './LeadForm.scss'
import { s3PublicStoragePrefix } from '../../../utility'
import { useSelector } from 'react-redux'
import props from '../../../redux/props'

window.afopt = {
  validation: {
    link_href: 'https://www.spd.de/',
    link_text: 'zurück zu SPD.de',
  },
  topics: ['QR-Plakat'],
  loadCss: 0,
}

const LeadForm = () => {
  const t = useSelector((s) => s[props.TRANSLATION])
  useEffect(() => {
    setTimeout(() => {
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = `${s3PublicStoragePrefix}custom-static-assets/leadFormScriptAdjusted.js`
      document.getElementById('leadform')?.appendChild(script)
    }, 500)
  })

  return (
    <div id="leadform">
      <div className="text-white font-bolder uppercase text-2xl leading-8 md:w-1/2">{t.leadform.headline}</div>
      <div id="leadform"></div>
    </div>
  )
}

export default LeadForm
